import React, { useCallback, useEffect, useState } from 'react'
import { getAllCategories, getAllFournisseurs } from '../../store/settingsSlice';
import { getAllProduits } from '../../store/produitSlice';
import { useDispatch, useSelector } from 'react-redux';
import ModalForm from '../../components/common/ModalForm';
import { PlatForm } from '../../config';
import { getAllPlats, getProduitsParPlat } from '../../store/platSlice';
import { PlusIcon } from '@heroicons/react/24/solid';
import FormPlat from "./FormPlat"; // Vérifiez le chemin correct

function Plat() {

    const { produitList } = useSelector((state) => state.produit);
    const { platList, produitListParPlat, platListByFournisseur, platListByCategorie } = useSelector((state) => state.plat);
    const { fournisseurList, categorieList } = useSelector((state) => state.settings);

    const [ligneProduits, setLigneProduits] = useState(produitListParPlat);

    const [isPlatModifying, setIsPlatModifying] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isBtnDisabled, setIsBtnDisabled] = useState(false);
    const [searchTermPlat, setSearchTermPlat] = useState("");
    const [selectedPlat, setSelectedPlat] = useState();
    const [tempsPlat, setTempsPlat] = useState();
    const [filteredPlats, setFilteredPlats] = useState([]);




    const [formControls, setFormControls] = useState(PlatForm);
    const [formTitle, setformTitle] = useState("Ajouter un plat");


    const dispatch = useDispatch();

    useEffect(() => {

        dispatch(getAllFournisseurs());
        dispatch(getAllCategories());
        dispatch(getAllProduits());
        dispatch(getAllPlats());

        setLigneProduits(produitListParPlat);
        if (platList && platList.length > 0) {
            setSelectedPlat(platList[0]);
        }

        if (selectedPlat) {
            dispatch(getProduitsParPlat(selectedPlat.id));
        }

    }, [getAllProduits, getAllCategories, getAllFournisseurs, getAllPlats, getProduitsParPlat]);


    useEffect(() => {
        // Plat filter
        if (platList && platList.length > 0) {
            const lowerSearch = searchTermPlat.toLowerCase();
            const filteredP = platList.filter(
                (plat) =>
                    plat.designation.toLowerCase().includes(lowerSearch) ||
                    plat.description?.toLowerCase().includes(lowerSearch)
            );
            setFilteredPlats(filteredP);

            if (!isPlatModifying) {
                setSelectedPlat(filteredP[0]);
            }
            setIsPlatModifying(false);
            dispatch(getProduitsParPlat(filteredP[0].id));
        }

    }, [platList, searchTermPlat]);


    const addField = (form) => {

        const formattedCategorieList = categorieList
            .filter((categorie) =>
                categorie.designation.startsWith("Menu")
            )
            ?.map((categorie) => ({
                id: categorie.id.toString(),
                label: categorie.designation,
            }))
            .sort((a, b) => a.label.localeCompare(b.label)) || [];

        // Mettez à jour le formulaire avec un nouveau champ pour la catégorie
        const updatedForm = [
            ...form, // Copie des champs existants
            {
                label: "Catégorie",
                name: "categorieid",
                componentType: "select",
                options: formattedCategorieList,
            },
            {
                label: "Description",
                name: "description",
                componentType: "textarea",
                placeholder: "Entrez une description",
            },
        ];

        // Définissez les contrôles du formulaire
        setFormControls(updatedForm);

    };

    // retourner le nom du produit par son id
    const getProduitNameById = (id) => {
        const produit = produitList.find((prod) => prod.id === id);
        return produit ? produit.designation : 'Produit introuvable';
    };

    // Retourner l'unite du produit par son id
    const getProdUnite = (id) => {
        const produit = produitList.find((prod) => prod.id === id);
        return produit ? produit.unite : 'Unite introuvable';
    };


    const handleSearPchChange = useCallback((e) => {
        setSearchTermPlat(e.target.value);
    }, []);


    function handleModal(formFourni) {

        switch (formFourni) {
            case 'PlatAdd':
                addField(PlatForm);
                setformTitle("Ajouter un plat");
                break;

            case 'PlatEditForm':
                addField(PlatForm);
                setformTitle("Modifier un plat");
                break;

            default:
                addField(PlatForm);
                setformTitle("Ajouter un plat");
                break;
        }

        setIsModalOpen(true); // Ouvre le modal
    }


    function formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    /* const [selectedIndex, setSelectedIndex] = useState(0); // Index de l'élément actif
 
     const handleKeyDown = (e) => {
         if (e.key === 'ArrowDown') {
             setSelectedIndex((prevIndex) =>
                 prevIndex < filteredPlats.length - 1 ? prevIndex + 1 : 0
             );
             const plat = filteredPlats[selectedIndex];
             setSelectedPlat(plat);
             dispatch(getProduitsParPlat(plat.id));
             console.log(plat);
         } else if (e.key === 'ArrowUp') {
             setSelectedIndex((prevIndex) =>
                 prevIndex > 0 ? prevIndex - 1 : filteredPlats.length - 1
             );
             const plat = filteredPlats[selectedIndex];
             setSelectedPlat(plat);
             dispatch(getProduitsParPlat(plat.id));
             console.log(plat);
         } else if (e.key === 'Enter') {
             const plat = filteredPlats[selectedIndex];
             setSelectedPlat(plat);
             dispatch(getProduitsParPlat(plat.id));
             console.log(plat);
         }
     };
 
     // Ajoute un écouteur d'événements au montage et le supprime au démontage
     useEffect(() => {
         window.addEventListener('keydown', handleKeyDown);
         return () => {
             window.removeEventListener('keydown', handleKeyDown);
         };
     }, [selectedIndex, filteredPlats]);
 */

    return (
        <div className="bg-gray-100">

            {/* Sales Overview */}
            <div className="mb-6 card">

                {/* header */}
                <div className="flex flex-row justify-between card-header">
                    <h1 className="h6">Résumé des ventes des produits</h1>

                    <div className="flex flex-row justify-center items-center">

                        <a href="">
                            <i className="mr-6 fa-chevron-double-down fad"></i>
                        </a>

                        <a href="">
                            <i className="fa-ellipsis-v fad"></i>
                        </a>

                    </div>

                </div>
                {/* end header */}

                {/* body */}
                <div className="gap-6 grid grid-cols-2 lg:grid-cols-1 card-body">

                    <div className="px-8 py-4">
                        <h1 className="h2">150 337.50</h1>
                        <p className="font-medium text-black">Ventes du mois en KMF</p>

                        <div className="flex items-center mt-10 mb-2">
                            <div className="bg-green-200 mr-3 px-3 py-1 rounded text-green-900">
                                <i className="fa fa-caret-up"></i>
                            </div>
                            <p className="text-black"><span className="num-2 text-green-400"></span><span className="text-green-400">% more sales</span> in comparison to last month.</p>
                        </div>

                        <div className="flex items-center">
                            <div className="bg-red-200 mr-3 px-3 py-1 rounded text-red-900">
                                <i className="fa fa-caret-down"></i>
                            </div>
                            <p className="text-black"><span className="num-2 text-red-400"></span><span className="text-red-400">% revenue per sale</span> in comparison to last month.</p>
                        </div>

                        <a href="#" className="btn-shadow mt-6">view details</a>

                    </div>

                </div>
                {/* end body */}

            </div>
            {/* end Sales Overview */}

            {/* start numbers */}
            <div className="gap-6 grid grid-cols-5 xl:grid-cols-2">

                {/* card */}
                <div className="mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-indigo-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-wallet fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> Sales</h1>
                            <p className="text-xs"><span className="num-2"></span> payments</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-green-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-shopping-cart fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> Orders</h1>
                            <p className="text-xs"><span className="num-2"></span> items</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="mt-1 xl:mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-yellow-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-blog fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> posts</h1>
                            <p className="text-xs"><span className="num-2"></span> active</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="mt-1 xl:mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-red-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-comments fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> comments</h1>
                            <p className="text-xs"><span className="num-2"></span> approved</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

                {/* card */}
                <div className="xl:col-span-2 mt-1 xl:mt-1 card">
                    <div className="flex items-center card-body">

                        <div className="bg-pink-600 mr-3 px-3 py-2 rounded text-white">
                            <i className="fa-user fad"></i>
                        </div>

                        <div className="flex flex-col">
                            <h1 className="font-semibold"><span className="num-2"></span> memebrs</h1>
                            <p className="text-xs"><span className="num-2"></span> online</p>
                        </div>

                    </div>
                </div>
                {/* end card */}

            </div>
            {/* end nmbers */}




            <div className="flex sm:flex-row md:flex-col flex-1 gap-4 bg-gray-100 md:mt-16 py-6">


                <div className="col-span-1 bg-white p-6 border rounded">
                    <div className="grid grid-cols-8 mb-2 px-3 border-b">
                        <PlusIcon
                            onClick={() => {
                                setTempsPlat(selectedPlat);
                                setSelectedPlat(null);
                                handleModal('PlatAdd');
                            }}
                            title='Ajouter un plat'
                            className="col-span-1 pt-3 w-9 h-9 text-teal-400 cursor-pointer" />
                        <form action="" className="flex col-span-7">
                            <input
                                className="flex-1 p-3 focus:outline-none"
                                type="text"
                                placeholder="Recherche..."
                                value={searchTermPlat}
                                onChange={handleSearPchChange}
                            />
                        </form>
                    </div>

                    <div>
                        <h2 className="mb-4 font-bold text-lg">Menus</h2>
                        {/* item */}
                        <ul className="space-y-2 min-h-[610px] max-h-[610px] overflow-y-scroll">
                            {filteredPlats.map((plat, index) => (
                                <li
                                    className={`
                                                flex flex-row items-center hover:bg-teal-500 active:bg-teal-500 px-3 py-2
                                                text-gray-600 text-left text-sm hover:text-white duration-800 cursor-pointer
                                                ${/*index === selectedIndex ? "bg-teal-500 text-white" :*/ plat.id === selectedPlat?.id
                                            ? "bg-teal-500 text-white"
                                            : ""
                                        }
                                    `}
                                    key={plat.id}
                                    onClick={() => {
                                        setSelectedPlat(plat);
                                        dispatch(getProduitsParPlat(plat.id));
                                    }}
                                >
                                    {plat.designation}
                                </li>
                            ))}
                        </ul>

                        {/* end item */}
                    </div>
                </div>

                {/* Main Content */}
                <div className="flex flex-col flex-1 bg-white p-6 border rounded">
                    <div className="flex flex-col flex-1">
                        <div className="relative w-full">
                            {/* Tabs Header */}

                            {/* Tabs Content */}
                            <div className="p-4">
                                {/* Détails de la catégorie */}
                                {selectedPlat ? (
                                    <div className="flex-1 p-6 min-h-[700px] max-h-[540px] overflow-y-scroll">
                                        <div className="flex justify-between items-center mb-4">
                                            <h1 className="font-bold text-2xl">{selectedPlat.designation}</h1>
                                            <span
                                                className={`text-sm font-medium px-3 py-1 rounded ${selectedPlat.disable ? "bg-red-500 text-white" : "bg-green-500 text-white"
                                                    }`}
                                            >
                                                {selectedPlat.disable ? "Inactive" : "Active"}
                                            </span>
                                        </div>
                                        <div className="space-y-4 text-gray-600">
                                            <div className='flex justify-between border-y py-6'>
                                                <div>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className='pr-3'><strong>Coût.T.production : </strong></td>
                                                                <td>{formatPrice(selectedPlat.prixTotalRevient)} Kmf</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='pr-3'><strong>Nb Menu : </strong></td>
                                                                <td>{selectedPlat.nbPortion} Menu</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='pr-3'><strong> Coût unitaire : </strong></td>
                                                                <td>{selectedPlat.prixUnitaire} Kmf</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='pr-3'><strong> Prix.V.U.H.T : </strong></td>
                                                                <td>{selectedPlat.prixVUHT} Kmf</td>
                                                            </tr>
                                                            <tr className={` ${selectedPlat.margeBrute < 0 ? "text-red-500" : "text-green-500"}`}>
                                                                <td className='pr-3'><strong>Prix de vente : </strong></td>
                                                                <td>{formatPrice(selectedPlat.prixVente)} Kmf</td>
                                                            </tr>
                                                            <tr className={` ${selectedPlat.margeBrute < 0 ? "text-red-500" : "text-green-500"}`}>
                                                                <td className='pr-3'><strong>Marge Brute: </strong></td>
                                                                <td>{formatPrice(selectedPlat.margeBrute)} Kmf</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div>
                                                    <img
                                                        className='rounded w-40 h-40 object-cover'
                                                        src={selectedPlat.photo} alt={selectedPlat.designation} />
                                                </div>
                                            </div>

                                            {selectedPlat.description && selectedPlat.description.split("\n").map((paragraph, index) => (
                                                <p key={index}>{paragraph}</p>
                                            ))}

                                        </div>
                                        {/* start Fournisseurs */}

                                        <div className='bg-gray-100 mt-6 px-4 py-2 rounded'>
                                            <span className='font-semibold'>List d'ingredients du plat</span>
                                        </div>
                                        <table className="table-fixed w-full">
                                            {/* table head */}
                                            <thead className="text-left">
                                                <tr className=''>
                                                    <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Produit</th>
                                                    <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Quantité </th>
                                                    <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Prix de revient</th>
                                                </tr>
                                            </thead>
                                            {/* end table head */}

                                            {/* table body */}
                                            <tbody className="text-gray-600 text-sm">
                                                {produitListParPlat.map((produit) => (
                                                    <tr className="hover:bg-teal-500 hover:text-white" key={produit.ProduitId}>
                                                        {/* name */}
                                                        <td className="border-1 px-2 py-1 border">
                                                            {getProduitNameById(produit.ProduitId)}
                                                        </td>
                                                        {/* name */}

                                                        {/* product */}
                                                        <td className="px-2 py-1 border border-l-0">
                                                            {produit.uniteNecessaire} {getProdUnite(produit.ProduitId)}
                                                        </td>
                                                        {/* product */}

                                                        {/* invoice */}
                                                        <td className="px-2 py-1 border border-l-0">
                                                            {formatPrice(produit.prixRevient)} KMF
                                                        </td>
                                                        {/* invoice */}

                                                    </tr>

                                                ))}

                                            </tbody>
                                            {/* end table body */}
                                        </table>
                                        {/* end Fournisseur */}

                                    </div>
                                ) : (
                                    <div className="flex-1 p-6 min-h-[500px] max-h-[500px] overflow-y-scroll">
                                        <p>Chargement des données...</p>
                                    </div>
                                )}
                                {/* Footer avec le bouton Modifier */}
                                <footer className="flex justify-between items-center p-4 border-t">
                                    <button
                                        onClick={() => {
                                            //handleDelete(selectedFournisseur.id);
                                        }}
                                        className="bg-red-500 hover:bg-red-600 px-4 py-2 rounded text-white transition"
                                    >
                                        Supprimer
                                    </button>

                                    <button
                                        onClick={() => {
                                            setSelectedPlat(selectedPlat);
                                            dispatch(getProduitsParPlat(selectedPlat.id));
                                            handleModal('PlatEditForm');
                                            setformTitle("Modifier le plat");
                                            setTempsPlat(selectedPlat);
                                        }}
                                        className="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded text-white transition"
                                    >
                                        Modifier
                                    </button>
                                </footer>

                            </div>
                        </div>
                    </div>
                    <div className="flex justify-between card-footer">
                        <p>4.41 GB (25%) of 17 GB used Manage</p>
                        <p>Last account activity: 36 minutes ago</p>
                    </div>
                </div>


            </div>
            <ModalForm
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false)
                    setSelectedPlat(tempsPlat);
                }}
                children={
                    <FormPlat
                        platFormControls={formControls}
                        formTitle={formTitle}
                        isLigneProduit={produitListParPlat}
                        isDataEdit={selectedPlat}
                        produitOptions={produitList}
                        setIsModalOpen={setIsModalOpen}
                        onPlatUpdated={(updatedPlat) => {
                            setIsPlatModifying(true);
                            setSelectedPlat(updatedPlat);
                        }
                        } // Ajout du callback

                    />
                }
            />
        </div>
    )
}

export default Plat